/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Department } from '@shared/models';

export interface DepartmentsState {
  /** Reihenfolge kommt vom Backend (sortOrder, dann Name) und wird nicht umsortiert. */
  departments: Department[];
  currentDepartment?: Department;
  isActionPending: boolean;
}

export const initialState: DepartmentsState = {
  departments: [],
  isActionPending: false
};
